
    import './styles.scoped.css';
    export default {
  "segment__path": "awsui_segment__path_1edmh_1shwq_17",
  "segment": "awsui_segment_1edmh_1shwq_17",
  "segment__hover": "awsui_segment__hover_1edmh_1shwq_44",
  "label": "awsui_label_1edmh_1shwq_58",
  "root": "awsui_root_1edmh_1shwq_72",
  "content": "awsui_content_1edmh_1shwq_76",
  "content--small": "awsui_content--small_1edmh_1shwq_76",
  "content--fit-height": "awsui_content--fit-height_1edmh_1shwq_79",
  "content--without-labels": "awsui_content--without-labels_1edmh_1shwq_82",
  "content--medium": "awsui_content--medium_1edmh_1shwq_88",
  "content--large": "awsui_content--large_1edmh_1shwq_100",
  "status-container": "awsui_status-container_1edmh_1shwq_117",
  "chart-container": "awsui_chart-container_1edmh_1shwq_121",
  "chart-container--fit-height": "awsui_chart-container--fit-height_1edmh_1shwq_125",
  "chart-container-chart-plot": "awsui_chart-container-chart-plot_1edmh_1shwq_130",
  "chart-container-chart-plot--fit-height": "awsui_chart-container-chart-plot--fit-height_1edmh_1shwq_133",
  "inner-content": "awsui_inner-content_1edmh_1shwq_139",
  "segment__highlight": "awsui_segment__highlight_1edmh_1shwq_150",
  "segment--dimmed": "awsui_segment--dimmed_1edmh_1shwq_165",
  "segment--highlighted": "awsui_segment--highlighted_1edmh_1shwq_168",
  "label--dimmed": "awsui_label--dimmed_1edmh_1shwq_185",
  "label--align-right": "awsui_label--align-right_1edmh_1shwq_188",
  "label-text": "awsui_label-text_1edmh_1shwq_196",
  "label__description": "awsui_label__description_1edmh_1shwq_204",
  "label-line": "awsui_label-line_1edmh_1shwq_211",
  "label--highlighted": "awsui_label--highlighted_1edmh_1shwq_215",
  "popover-header": "awsui_popover-header_1edmh_1shwq_219"
};
  